import { Search } from "@mui/icons-material";
import { Box, Chip, Grid, InputAdornment, Popover, TextField } from "@mui/material";
import { ChangeEventHandler, useState } from "react";
import { ErrorMessage } from "../../App/Components/Forms/formHelpers";
import { ITablePagination } from "../../App/Typings/SortableTable";

export const MaxSearchLength = 100;

export const ImportSearchBar = ({
  defaultValue,
  error,
  errorMessage,
  placeholder,
  label,
  dataTestId,
  onChange,
}: {
  defaultValue: string;
  error: boolean;
  errorMessage: string;
  placeholder: string;
  label: string;
  dataTestId?: string;
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}) => {
  return (
    <Box sx={{ my: 2 }}>
      <TextField
        label={label}
        defaultValue={defaultValue}
        onChange={onChange}
        type="search"
        sx={{ width: "60ch", maxWidth: "100%" }}
        error={error}
        placeholder={placeholder}
        data-test={dataTestId}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        }}
      />
      {errorMessage && <ErrorMessage message={errorMessage} />}
    </Box>
  );
};

export const renderTablePaginationDisplay = ({
  from,
  to,
  count,
  isLoading,
  search,
  itemName,
}: {
  from: number;
  to: number;
  count: number;
  isLoading: boolean;
  search: string;
  itemName?: string;
}) => {
  if (isLoading || count === 0) {
    return "---";
  }
  if (search !== "") {
    return `${from}-${to} of ${count}${itemName ? " " + itemName : ""} (filtered)`;
  }
  return `${from}-${to} of ${count} total${itemName ? " " + itemName : ""}`;
};

export const paginationOptions: ITablePagination = {
  rowsPerPage: [10, 25, 50, 100],
  enabled: true,
};

export function AttachmentsPopover({ attachments }: { attachments: string[] }) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: any) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "attachments-popover" : undefined;

  return attachments && attachments.length > 0 ? (
    <>
      {attachments.map((attachment: string, idx: number) => (
        <Chip
          key={`attachment-${idx}-${attachment}`}
          label={attachment}
          size="small"
          sx={{ ml: 1 }}
          color="secondary"
          onClick={handleClick}
        />
      ))}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Grid container sx={{ maxWidth: 300, p: 1 }}>
          {attachments.map((attachment: string, idx: number) => (
            <Grid key={`popover-item-${idx}-${attachment}`} item sx={{ m: 0.5 }}>
              <Chip key={idx} label={attachment} size="small" sx={{ ml: 1 }} color="secondary" />
            </Grid>
          ))}
        </Grid>
      </Popover>
    </>
  ) : (
    <></>
  );
}
